<template>
  <navbar>
    <button ref="SidebarToggler" class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">&#9776;</button>
    <ul class="nav navbar-nav d-md-down-none">
      <li class="nav-item">
        <a class="nav-link navbar-toggler sidebar-toggler" href="#" @click="sidebarMinimize">&#9776;</a>
      </li>
    </ul>
    <router-link :to="{ name: 'PaginaInicial' }" class="navbar-brand"><small :class="display"></small></router-link>
    <ul class="nav navbar-nav ml-auto">
      <b-dropdown class="notificaAgenda" variant="link" right lazy no-caret>
        <template #button-content>
          <div class="d-flex align-items-center" style="height: 35px;">
            <div>
              <i class="text-light nav-item fas fa-calendar fa-lg">
                <span
                  v-if="newSchedule.length !== 0"
                  class="badge badge-pill badge-default bg-danger"
                >{{ newSchedule.length }}</span>
              </i>
            </div>
          </div>
        </template>
        <b-dropdown-form>
          <Agenda @openCard="showLead"></Agenda>
        </b-dropdown-form>
      </b-dropdown>
      <b-dropdown class="notificaOportunidades" variant="link" ref="alert-dropdown" right lazy no-caret>
        <template #button-content>
          <div class="d-flex align-items-center" style="height: 35px;">
            <div>
              <i class="text-light nav-item fas fa-bell fa-lg">
                <span
                  v-if="newOportunities.length !== 0"
                  class="badge badge-pill badge-default bg-danger"
                >{{ newOportunities.length }}</span>
              </i>
            </div>
          </div>
        </template>
        <b-dropdown-form>
          <oportunidades @openCard="showLead"></oportunidades>
        </b-dropdown-form>
      </b-dropdown>
      <li class="divider-vertical d-md-down-none mr-3"></li>
      <b-dropdown variant="link" no-caret class="je-test">
        <template slot="button-content">
          <b-avatar class="mr-2"></b-avatar>
          <span class="d-md-down-none" style="min-width: 190px; color: #fff;">{{AccountName}}</span>
          <i class="fa fa-caret-down" style="color:#fff;"></i>
        </template>
        <b-dropdown-item :to="{ name: 'AlterarSenha' }"><i class="fa fa-key" href="javascript:void(0)"></i>Alterar Senha</b-dropdown-item>
        <b-dropdown-item v-if="isAdministrador" :to="{ name: 'Environment' }" href="javascript:void(0)"><i class="fa fa-cogs"></i> Configuração</b-dropdown-item>
        <b-dropdown-item href="javascript:void(0)" @click="onSignOut"><i class="fa fa-lock"></i> Sair</b-dropdown-item>
      </b-dropdown>

      <li class="pr5 d-md-down-none">&nbsp;</li>
    </ul>
    <ModalCard ref="ModalCard" v-if="selectedCard" @hideModal="hideLead" :key="selectedCard" :cardId="selectedCard" />
  </navbar>
</template>
<script>
import AccountMixin from '@/store/module/account/mixin'
import { JWTService } from '@/shared/services/jwt'
import Tools from '@/components/tools/Tools.js'
import router from '@/router'
import navbar from './Navbar'
import Agenda from '../../components/UI/notificacao/Agenda.vue'
import Oportunidades from '../../components/UI/notificacao/Oportunidades.vue'
import NotificationsCardRepository from '@/shared/http/repositories/crm/notificationscard.js'
import ModalCard from '@/views/private/crm/components/modalCard/modalCard.vue'

export default {
  name: 'headerApp',
  mixins: [AccountMixin],
  data () {
    return {
      isAdministrador: false,
      display: '',
      imgAvatar: process.env.BaseURL + 'static/img/avatars/02.png',
      screenW: screen.width,
      newOportunities: [],
      newSchedule: [],
      selectedCard: null
    }
  },
  components: {
    navbar,
    Agenda,
    Oportunidades,
    ModalCard
  },
  created () {
    if (JWTService.GetRoles().includes('ADMINISTRADOR')) {
      this.isAdministrador = true
    }
    this.getNotificationAndSchedule()
  },
  computed: {
    AccountName: function () {
      var result = JWTService.GetTokenPayload().nome
      if (this.account && this.account.name) {
        result = this.account.name
      } else if (result !== '') {
        result = result.toUpperCase()
      }
      return result
    }
  },
  methods: {
    onSignOut () {
      JWTService.DestroyToken()
      router.replace('/login')
    },
    click () {
      // do nothing
    },
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
      // this.display = 'none'
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    },
    getInitialName (value) {
      return Tools.getInitialsOfName(value)
    },
    getNotificationAndSchedule () {
      NotificationsCardRepository.searchNotificationsUserCustom('visualizado=false')
        .then(response => {
          this.newOportunities = response.data.content
        })
      NotificationsCardRepository.searchNotificationsUserCustom('visualizado=false&agendamento=true')
        .then(response => {
          this.newSchedule = response.data.content
        })
    },
    showLead (cardId) {
      this.selectedCard = cardId
    },
    hideLead () {
      this.selectedCard = null
    }
  }
}
</script>
<style>
.je-test ul {
  transform: translate3d(0px, 53px, 0px);
}

.notification {
  background-color: #dee2e5;
}

@media only screen and (max-width: 600px){

  .notificaOportunidades.dropdown.b-dropdown > .dropdown-menu{
    transform: translate3d(-30px, 53px, 0px) !important;
  }
  .notificaAgenda.dropdown.b-dropdown > .dropdown-menu{
    transform: translate3d(10.5px, 53px, 0px) !important;
  }
  .notificaAgenda > button{
    margin-right: -.75rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/layout/Header.vue